import {action, makeObservable, observable} from 'mobx'

export class RunlabLayoutStore {
  @observable
  data: LayoutData

  @observable
  ui = {
    header: {
      height: 0,
    },
    mobile: {
      menu: {
        opened: false,
      },
    },
  }

  constructor(data: LayoutData) {
    this.data = data
    makeObservable(this)
  }

  @action.bound
  setData(data: LayoutData) {
    this.data = data
  }

  @action.bound
  onPathChanged() {
    this.ui.mobile.menu.opened = false
  }

  @action.bound
  setMobileOpened(open: boolean) {
    this.ui.mobile.menu.opened = open
  }

  @action.bound
  setHeaderHeight(height: number) {
    this.ui.header.height = height
  }

  @action.bound
  clearSession() {
    this.data.session = null
  }
}
